<template lang="pug">
    div(class="operator-container")
        div.img-container
          img(src="@/assets/img/operator.png" alt="operator")
        div(class="speechBubble")
            p(class="speechText")
                |{{ text }}
</template>
<script>
export default {
  name: "Operator",
  props: {
    text: { type: String, required: true }
  }
};
</script>
